import { JDSBadgeV2InformationProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSBadgeV2InformationProps>
  ): React.FC<JDSBadgeV2InformationProps> =>
  (props: JDSBadgeV2InformationProps) => {
    return <Component {...props} />;
  };
